module.exports = __webpack_public_path__ + "img/icloud.7a104269.svg";